/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PlatformRefDTO
 */
export interface PlatformRefDTO {
  /**
   *
   * @type {number}
   * @memberof PlatformRefDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PlatformRefDTO
   */
  name?: string;
}

/**
 * Check if a given object implements the PlatformRefDTO interface.
 */
export function instanceOfPlatformRefDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;

  return isInstance;
}

export function PlatformRefDTOFromJSON(json: any): PlatformRefDTO {
  return PlatformRefDTOFromJSONTyped(json, false);
}

export function PlatformRefDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformRefDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: !exists(json, "name") ? undefined : json["name"]
  };
}

export function PlatformRefDTOToJSON(value?: PlatformRefDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name
  };
}
